// extracted by mini-css-extract-plugin
export var copyableField = "_oh-4";
export var customerBadge = "_oh-0";
export var customerInfoTitle = "_oh-2";
export var details = "_oh-1";
export var dropdownContainer = "_oh-5";
export var dropdownImage = "_oh-6";
export var editAssigneeForm = "_oh-a";
export var editButton = "_oh-3";
export var email = "_oh-7";
export var hidden = "_oh-d";
export var input = "_oh-8";
export var saveButton = "_oh-b";
export var shopifyIcon = "_oh-c";
export var suggestionBadge = "_oh-e";
export var suggestionText = "_oh-f";
export var username = "_oh-9";